/**
 * generate an array  of  element ( a range )
 * @param start
 * @param end
 * @param steps
 * @returns {IterableIterator<*>}
 */
function* range(start, end, steps = 1) {
  for (let i = start; i <= end; i += steps) {
    yield i;
  }
}

const generateMonthList = (startingMonth, MonthLength) => [
  ...range(startingMonth, MonthLength),
];

const generateYearList = (startingYear, yearLength) => [
  ...range(startingYear, yearLength),
];
export { generateMonthList, generateYearList };



// WEBPACK FOOTER //
// ./src/utils/dates.js